import React from 'react';

import { ConfirmDialog, Typography } from '@occc-app/design-system';

type ArchiveConfirmDialogProps = {
  open: boolean;
  componentName: string;
  isArchiving: boolean;
  onClose: (event: React.SyntheticEvent) => void;
  onConfirm: (event: React.SyntheticEvent) => void;
};

export const ArchiveConfirmDialog = ({
  open,
  componentName,
  isArchiving,
  onClose,
  onConfirm,
}: ArchiveConfirmDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Are you sure?'
      open={open}
      onClose={onClose}
      confirmButtonText='Confirm'
      confirmButtonProps={{
        onClick: onConfirm,
        color: 'error',
        disabled: isArchiving,
      }}
    >
      <Typography>{`This action will archive the "${componentName}".`}</Typography>
    </ConfirmDialog>
  );
};
